<template>
  <div class="performance-wrapper">
    <sticky>
      <div class="clearfix header-panel">
        <div class="header">
          <span class="notice-header">
            {{ $i18n.t('performance.title') }}
          </span>
        </div>
        <div class="right-btns">
          <button
            type="button"
            class="btn btn--darkblue"
            @click="resetFilter"
          >{{ $t('action.resetFilter') }}</button>
          <button
            type="button"
            class="btn btn--orange"
            @click="doSearch"
          >{{ $t('action.search') }}</button>
        </div>
      </div>
    </sticky>

    <div
      class="filter-area"
      @keydown.enter="doSearch"
    >
      <search-filter
        v-for="item in advanceList"
        :label="item.title"
        :key="item.name"
        :inputType="item.inputType"
        :type="item.name"
        :options="getOption(item)"
        :multiple="item.multiple"
        :value="getValue(item)"
        :searchable="item.searchable"
        :onchange="changeSearchConditions"
      />
    </div>

    <div class="preformance-view-all-container">
      <template>
        <span style="margin-left: 15px;">{{ $t('total') }}: {{ companiesList.length ? `${displayLength} / ${companiesList.length}` : 0 }}</span>
        <CommonTable
          ref="performance-view-all-table"
          tableId="performance-view-all-table"
          :renderHeaderList="tableList"
          :tableContentLists="filteredList"
          :getDisplayListLength="getDisplayListLength"
          :needFilter="true"
          :defaultOrder="true"
          defaultOrderKey="name"
          :afterMounted="afterCommonTableMounted"
          :interactionFunc="interactionFunc"
          :enterEvent="doSearch"
          :orderMethods="orderMethods"
          :orderByNumberKeys="['averageScore', 'evaluationCount', 'projectCount', 'invitedCount']"
        />
      </template>
    </div>
  </div>
</template>

<script>
import lodash from 'lodash'
import { mapGetters, mapMutations } from 'vuex'

import CommonTable from '@/controls/CommonTable'
import HomeLink from '@/controls/HomeLink'
import Sticky from '@/controls/Sticky'

import mutationTypes from '@/store/mutation-types'
import SearchFilter from '../contacts/SearchFilter'
import { getAdvancedList } from './Contains'
import { expandTradeCategories, getPerformanceList, normalizeTradeCategorySelections, setupOptions } from '@/api/performance/request'
import { ONE_DAY_MILLI } from '@/utils/dateUtil'

function defaultSearchConditions () {
  return {
    name: { value: '' },
    dateRange: { value: [] },
    site: { value: [] },
    trade: { value: [] },
    accumulated: { value: [] },
  }
}

export default {
  name: 'PerformanceIndex',
  components: {
    Sticky,
    SearchFilter,
    HomeLink,
    CommonTable,
  },

  data () {
    const defaultData = {
      searchItems: {},
      searchConditions: defaultSearchConditions(),
      companiesList: [],
      sortAscending: true,
      sortByKey: 'name',
      displayLength: 0,
      extendfilterConditons: {value: []},
      orderMethods: {
        declined: this.doSort,
        noshow: this.doSort,
        totalAwarded: this.doSort,
        highestQuotation: this.doSort,
        accumulatedPO: this.doSort,
      },
    }
    return {
      ...defaultData,
      filteredList: [],
      performanceOptions: {},
      showItemLink: ['name', 'averageScore'],
      interactionFunc: {
        name: this.navToCompanyDetail,
        averageScore: this.navToAveragePage,
      },
    }
  },
  computed: {
    ...mapGetters('ccd', ['performanceSearchConditions']),
    advanceList: getAdvancedList,
    tableList () {
      return [{
        title: this.$t('company.performance.companyName'),
        inputType: 'input',
        name: 'name',
      }, {
        title: this.$t('company.performance.averageScore'),
        inputType: 'input',
        name: 'averageScore',
        defaultValue: '--',
      }, {
        title: this.$t('company.performance.numberOfEvaluation'),
        inputType: 'input',
        name: 'evaluationCount',
        defaultValue: '--',
      }, {
        title: this.$t('company.performance.numberOfProject'),
        inputType: 'input',
        name: 'projectCount',
        defaultValue: '--',
      }, {
        title: this.$t('company.performance.accumulatedPo', [this.$globalProps.getCurrency()]),
        inputType: 'input',
        name: 'accumulatedPO',
        defaultValue: '--',
      }, {
        title: this.$t('company.performance.inviated'),
        inputType: 'input',
        name: 'invitedCount',
        defaultValue: '--',
      }, {
        title: this.$t('company.performance.decline'),
        inputType: 'input',
        name: 'declined',
        defaultValue: '--',
      }, {
        title: this.$t('company.performance.noShow'),
        inputType: 'input',
        name: 'noshow',
        defaultValue: '--',
      }, {
        title: this.$t('company.performance.awarded'),
        inputType: 'input',
        name: 'totalAwarded',
        defaultValue: '--',
      }, {
        title: this.$t('company.performance.highest'),
        inputType: 'input',
        name: 'highestQuotation',
        defaultValue: '--',
      }]
    },
  },
  methods: {
    ...mapMutations('ccd', {
      setSearchConditions: mutationTypes.PERFORMANCE_SEARCH_CONDITIONS,
    }),

    changeSearchItems (val) {
      this.searchItems = Object.assign({}, this.searchItems, val)
    },
    changeSearchConditions (val) {
      this.searchConditions = Object.assign({}, this.searchConditions, val)
    },
    triangleDirection (headerName) {
      return this.sortByKey === headerName ? (this.sortAscending ? 'triangle-up' : 'triangle-down') : ''
    },

    enableLink (item) {
      return this.showItemLink.includes(item.name)
    },

    resetFilter () {
      this.searchConditions = defaultSearchConditions()
      this.sortByKey = ''
      this.sortAscending = false
      this.setSearchConditions({ searchConditions: this.searchConditions })
      this.$refs['performance-view-all-table'].resetSearchOrFilter()
    },

    getFiltersForNavigation () {
      return {
        startDay: lodash.get(this.searchConditions, 'dateRange.value[0]', ''),
        endDay: lodash.get(this.searchConditions, 'dateRange.value[1]', ''),
        site: lodash.get(this.searchConditions, 'site.value', []),
        trade: lodash.get(this.searchConditions, 'trade.value', []),
      }
    },
    navToCompanyDetail (item) {
      this.$router.push({
        name: 'companyView',
        params: { id: item.key, ...this.getFiltersForNavigation() },
      })
    },
    navToAveragePage (item) {
      this.$router.push({
        name: 'performanceRatingHistory',
        params: {
          filter: 'average',
          ...this.getFiltersForNavigation(),
          companyId: item.key,
          description: item.name,
        },
      })
    },
    endDayToLastSecond (date) {
      if (date) {
        const seconds = (new Date(date)).getTime() + ONE_DAY_MILLI - 1
        return new Date(seconds)
      }
      return date
    },
    normalizeTradeSearchValue () {
      const categories = lodash.get(this.performanceOptions, 'categories', [])
      if (!categories.length) return

      this.searchConditions.trade.value = normalizeTradeCategorySelections(
        lodash.get(this.searchConditions, 'trade.value', []),
        categories,
      )
    },
    getExpandedTradeCategories () {
      return expandTradeCategories(
        lodash.get(this.searchConditions, 'trade.value', []),
        lodash.get(this.performanceOptions, 'categoryMap', {}),
      )
    },
    async doSearch () {
      const query = {
        startDay: lodash.get(this.searchConditions, 'dateRange.value[0]', ''),
        endDay: this.endDayToLastSecond(lodash.get(this.searchConditions, 'dateRange.value[1]', '')),
        vendorName: lodash.get(this.searchConditions, 'name.value'),
        site: lodash.get(this.searchConditions, 'site.value', []).join(','),
        category: this.getExpandedTradeCategories().join(','),
      }
      this.companiesList = await getPerformanceList(query)
      this.doFilterProjectList()
    },
    getValue (item) {
      return lodash.get(this.searchConditions, `${item.name}.value`, '')
    },

    getOption (item) {
      let option = []

      switch (item.name) {
        case 'site':
          option = this.performanceOptions.sites || []
          break
        case 'trade':
          option = this.performanceOptions.categories || []
          break
        default:
          break
      }
      return option
    },
    getDisplayListLength (len) {
      this.displayLength = len
    },
    doFilterProjectList () {
      const filters = this.searchConditions
      this.filteredList = this.companiesList.filter(company => {
        let flag = true
        for (let key in filters) {
          const value = lodash.get(filters, `${key}.value`)
          switch (key) {
            case 'name':
              if (value && !company[key].toLowerCase().includes(value.toLowerCase())) {
                flag = false
              }
              break
            case 'accumulated':
              if (value[0] && value[1]) {
                if (company['sumPurchaseAmounts'] < Number(value[0]) || company['sumPurchaseAmounts'] > Number(value[1])) {
                  flag = false
                }
              } else if (value[0]) {
                if (company['sumPurchaseAmounts'] < Number(value[0])) {
                  flag = false
                }
              } else if (value[1]) {
                if (company['sumPurchaseAmounts'] > Number(value[1])) {
                  flag = false
                }
              }
              break
          }
        }
        return flag
      })
    },
    doSort (item, order, orderKey) {
      let lastOne = order ? Number.MAX_SAFE_INTEGER : Number.MIN_SAFE_INTEGER
      let ret = lastOne
      switch (orderKey) {
        case 'declined':
        case 'noshow':
        case 'totalAwarded':
        case 'highestQuotation':
          ret = item.invitedCount ? parseInt(item[orderKey]) : lastOne
          break
        case 'accumulatedPO':
          ret = item['sumPurchaseAmounts'] || lastOne
          break
      }
      return ret
    },
    renderPercent (ele, denominator) {
      return denominator ? `${(ele / denominator * 100).toFixed(2)}% [${ele + ' of ' + denominator}]` : null
    },
    afterCommonTableMounted ({tableContent}) {
      this.companiesList = tableContent
    },
  },
  beforeDestroy () {
    this.setSearchConditions({ searchConditions: this.searchConditions })
  },
  mounted () {
    if (Object.keys(this.performanceSearchConditions).length) {
      this.searchConditions = lodash.cloneDeep(this.performanceSearchConditions)
    }
    this.normalizeTradeSearchValue()
    this.doFilterProjectList()
  },

  async created () {
    document.addEventListener('click', this.clickInPage)
    this.performanceOptions = await setupOptions()
    this.normalizeTradeSearchValue()
  },
}
</script>
<style scoped src="styles/dashboard/style.scss"></style>
<style scoped src="styles/dashboard/datatable.scss"></style>
<style lang="scss">
.performance-wrapper {
  input {
    margin: 0;
    padding: 0;
  }
  input[type='text'], input[type='number'], textarea[type='text'] {
    width: 100%;
    height: 40px;
    min-height: 0px;
  }
  .float-right {
    display: inline-block;
  }
  .header-section {
    background: #ebebeb;
    padding: 15px 24px;
    min-height: 61px;
    .goHome {
      position: absolute;
      top: 10px;
      cursor: pointer;
    }
    .goHome:before {
      content: "< ";
    }
    .header-title {
      font-size: 30px;
    }

  }
  .header-panel {
    padding: 15px 24px;
    background: white;
    .header {
      display: inline-block;
      .notice-header {
        font-family: Georgia;
        font-weight: bold;
        font-size: 22px;
        text-transform: uppercase;
      }
    }
    .right-btns {
      float: right;
      .btn {
        margin-left: 16px;
      }
    }
  }
  .filter-area {
    flex: 1;
    display: inline-block;
    padding: 0 24px 15px 24px;
    .search-filter-input {
      height: 70px;
      margin-right: 20px;
      input:not(.date-picker-class) {
        text-indent: 1rem;
      }
    }
  }
  .preformance-view-all-container {
    height: calc(100vh - 281px);
  }
  .performance-view-all-table_common-table {
    height: calc(100% - 36px);
    .common-table-header-container {
      min-width: 1860px;
    }
    .evaluationCount {
      min-width: 260px;
      max-width: 260px;
    }
    .projectCount {
      min-width: 240px;
      max-width: 240px;
    }
    .name {
      min-width: 220px;
      width: calc(100% - 1630px);
    }
    .averageScore {
      min-width: 180px;
      max-width: 180px;
    }
    .accumulatedPO {
      min-width: 200px;
      max-width: 200px;
    }
    &.common-table .common-table-content-container {
      height: calc(100% - 134px);
    }

    .invitedCount,
    .highestQuotation,
    .declined,
    .noshow,
    .totalAwarded{
      min-width: 150px;
      max-width: 150px;
    }

    /* Mirror title-row column widths — CommonTable .common-header-filter th { min-width: 0 } otherwise shifts labels. */
    .common-header-filter {
      th.name {
        min-width: 220px;
        width: calc(100% - 1630px);
      }
      th.averageScore {
        min-width: 180px;
        max-width: 180px;
      }
      th.evaluationCount {
        min-width: 260px;
        max-width: 260px;
      }
      th.projectCount {
        min-width: 240px;
        max-width: 240px;
      }
      th.accumulatedPO {
        min-width: 200px;
        max-width: 200px;
      }
      th.invitedCount,
      th.highestQuotation,
      th.declined,
      th.noshow,
      th.totalAwarded {
        min-width: 150px;
        max-width: 150px;
      }
    }
  }
}
</style>
